import * as React from "react"

export default function TicketOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5013 2.5C17.7223 2.5 17.9343 2.5878 18.0906 2.74408C18.2468 2.90036 18.3346 3.11232 18.3346 3.33333V7.91667C17.7821 7.91667 17.2522 8.13616 16.8615 8.52686C16.4708 8.91756 16.2513 9.44747 16.2513 10C16.2513 10.5525 16.4708 11.0824 16.8615 11.4731C17.2522 11.8638 17.7821 12.0833 18.3346 12.0833V16.6667C18.3346 16.8877 18.2468 17.0996 18.0906 17.2559C17.9343 17.4122 17.7223 17.5 17.5013 17.5H2.5013C2.28029 17.5 2.06833 17.4122 1.91205 17.2559C1.75577 17.0996 1.66797 16.8877 1.66797 16.6667V12.0833C2.2205 12.0833 2.75041 11.8638 3.14111 11.4731C3.53181 11.0824 3.7513 10.5525 3.7513 10C3.7513 9.44747 3.53181 8.91756 3.14111 8.52686C2.75041 8.13616 2.2205 7.91667 1.66797 7.91667V3.33333C1.66797 3.11232 1.75577 2.90036 1.91205 2.74408C2.06833 2.5878 2.28029 2.5 2.5013 2.5H17.5013ZM16.668 4.16667H3.33464V6.64L3.46464 6.7075C4.0299 7.01587 4.50624 7.4646 4.84777 8.01047C5.18931 8.55634 5.38453 9.18096 5.41464 9.82417L5.41797 10C5.41807 10.6735 5.23673 11.3347 4.89301 11.9139C4.54929 12.4931 4.05588 12.969 3.46464 13.2917L3.33464 13.36V15.8333H16.668V13.3592L16.538 13.2925C15.9727 12.9841 15.4964 12.5354 15.1548 11.9895C14.8133 11.4437 14.6181 10.819 14.588 10.1758L14.5846 10C14.5846 8.58 15.3738 7.34417 16.538 6.70833L16.668 6.63917V4.16667Z"
        fill={props.fill}
      />
    </svg>
  )
}